var NewHelpers = require('./helpers/helpers');

/*
  Oh hi! This looks new!  And boring.  Well, this is an A+ in code climate so
  I figured I would just make all of our files two lines... just kidding.

  The helpers that you have all come to know and love has grown too big for
  its baby clothes and it was time to move out of the house and have each
  family move into its own respective space.  You'll see a folder that has
  been cleverly named 'helpers' that contains a bunch of different categories.

  One such category is 'users.jsx' - you should look for the appropriate
  category when creating helpers and do the same.

  It is probably a good idea to get into the habit of doing something like:
  `Fraction.Helpers.Users.completeAccount()` instead of
  `Fraction.Helpers.completeAccount()` but this will still support the old
  way of doing things because it would have been way too much work to change that.

  The End
*/

module.exports = NewHelpers;
